export default {
  sidebar: {
    theme: 'Interface Theme',
    language: 'Language',
    pairing: 'Receiver Pairing',
    about: 'About',
    errorLog: 'Error Log',
  },
  themes: {
    gleam: 'Gleam',
    scroll: 'Scroll',
    pastel: 'Pastel',
    subtle: 'Subtle',
    stealth: 'Stealth',
    terminus: 'Terminus',
    hackruin: 'Hackruin',
    moonview: 'Moonview',
    pink: 'Pink',
    mound: 'Mound',
    velvetIsle: 'Velvet Isle',
    cloudNook: 'Cloud Nook',
    sunny: 'Sunny',
    gentle: 'Gentle',
    refract: 'Refract',
    neonBlue: 'Neon Blue',
  },
  languages: {
    zhCN: '中文',
    enUS: 'English',
  },
  theme: {
    customTitle: 'Custom',
    presetTitle: 'System Preset',
    custom: 'Custom',
    upload: 'Upload',
    deleteTitle: 'Delete Wallpaper',
    deleteConfirm: 'Are you sure you want to delete this custom wallpaper?',
    onlySupportImage: 'Only {types} image types are supported',
  },
  about: {
    contact: {
      title: 'Contact Us',
      description:
        'Please feel free to contact us with any suggestions or questions regarding our hardware products or software drivers; we are committed to continuous improvement to make the RAPOO user experience even more user-friendly.',
    },
    copyright: {
      title: 'Copyright',
      description: '{year} RAPOO. All rights reserved.',
      openSourceLicense: 'Open-Source Licenses',
    },
    notificationTitle: 'Notifications',
    run: {
      title: 'Runtime Settings',
      autoStartLabel: 'Autostart On Boot',
      silentBackgroundLabel: 'Automatic Silent Background Mode',
      closeActionOptions: {
        minimize: 'Minimize When Closed',
        exit: 'Exit When Closing',
      },
    },
    update: {
      title: 'Software Update',
      checkUpdatesButton: 'Check For Updates',
      latestVersion: 'Up to Date',
      currentVersion: 'Current Version V{version}',
      relaseNotes: 'Release Notes',
      checkUpdateDialog: {
        isLatestVersion: 'This is currently the latest version.',
        latestVersionText: 'Current Version: V{version}',
        confirmButton: 'Confirm',
        updatingText: 'Updating... Please wait. Currently',
        updatingTipText:
          'The device may restart during the update. This is normal, no action needed.',
        updateSuccess: 'Update Successful',
        UpdateError: 'Update Failed',
      },
      updateLogDialog: {
        title: 'Software Release Notes',
        confirmButton: 'Confirm',
      },
    },
    errorLog: {
      title: 'Error Log',
    },
  },
  device: {
    firmware: {
      title: 'Firmware Update',
      dongleTitle: 'Dongle Update',
      checkUpdatesButton: 'Check For Updates',
      currentVersion: 'Current Version V{version}',
      latestVersion: 'Latest Version V{version}',
      releaseNotes: 'Release Notes',
      latestVersionTip: 'The firmware is already the latest version.',
      unsupportedOnlineUpdate:
        'Online update is not supported for the current firmware. Please download the desktop A HUB driver to upgrade.',
      upgradeWarning:
        'During the firmware update, avoid unplugging the device or exiting the driver. Please reconnect the device after the update is complete.',
      upgradeWiredTip: 'Firmware upgrade requires a wired connection.',
      upgradingText: 'Upgrading... Please wait.',
      upgradeDongleWarning:
        'During the firmware update, avoid unplugging the device or exiting the driver. Please reconnect the device after the update is complete.',
      upgradingTipText:
        'The device may restart during the upgrade; this is normal and you can simply ignore it.',
      upgradeLogTitle: 'Firmware Release Notes',
      upgradeLogEmpty: 'No update logs available yet.',
      downloadFailed: 'Firmware download failed, please check your network.',
      hexNotFound: 'Firmware file (.hex) not found in the update package.',
      upgradingWarning: 'Firmware update is already in progress, please wait.',
      upgradeFailed: 'Firmware update failed, please try again.',
      boot: {
        defaultUpgraderName: 'Volt* Upgrader',
        confirmEnterBoot: {
          title: 'Enter Firmware Update Mode',
          body1Prefix: 'The device will enter update mode and may appear as',
          body1Suffix: '.',
          body2:
            'In the next system dialog, select the matching updater device and authorize the connection.',
          body3:
            'If authorization is not completed, the keyboard may stay in update mode. Unplug and reconnect to recover.',
          confirm: 'Continue',
        },
        authorizeBootDevice: {
          title: 'Select Updater Device',
          body1Prefix: 'Click the button below, then select in the system dialog:',
          body2: 'Do not select any other device, or the update cannot continue.',
          body3:
            'If you cancel authorization, the keyboard stays in update mode. Unplug and reconnect, then try again.',
          confirm: 'Select Device',
        },
        pickOwner: {
          title: 'Select Product to Resume Update',
          body1:
            'An updater device was detected, but the model could not be determined automatically (no prior connection after refresh).',
          body2: 'Select the product being updated to avoid downloading the wrong firmware:',
        },
      },
    },
    productColor: {
      title: 'Product Color Display',
    },
    lowBattery: {
      title: 'Low Battery Indicator',
      description: 'When battery is low, the mouse LED will flash frequently as a reminder.',
    },
    wirelessSleepTime: {
      title: 'Wireless Sleep Time',
      description:
        'The mouse will go to sleep if no operation is performed within the specified time.',
      tooltipContent:
        'In competitive hyper-core mode, the device operates at high power and full-speed scanning. It is recommended to set the timeout within 15 minutes to extend wireless battery life.',
      disableSleepTooltip: 'When disabled, the mouse will not automatically enter sleep mode.',
      shortTimeLabel: '2min',
      longTimeLabel: '120min',
      minuteUnit: 'min',
    },
    usbReportRate: {
      title: 'USB Report Rate',
    },
    frequencyBand: {
      title: 'Frequency Band',
      description:
        'After adjusting the frequency band, place the mouse back on the base to re-pair for the change to take effect.',
    },
    brightness: {
      title: 'Display Brightness',
    },
    factoryReset: {
      title: 'Factory Reset',
      buttonText: 'Reset',
      description: 'Reset will delete all personalized settings.',
      dialogDescription:
        'All personalized settings will be deleted. Are you sure you want to restore factory settings?',
      successMessage: 'Factory reset successful.',
    },
  },
  pairing: {
    emptyText: 'No device detected, please retry',
    selectTitle: 'Select the product device model for receiver pairing',
    selectDescription:
      '1. Connect the product to be paired to the computer in wired mode; 2. Select the device to pair with the receiver, then click Continue',
    connectDeviceBtn: 'Connect Device',
    addDeviceBtn: 'Add Pairing Device',
    continueBtn: 'Continue (Enter)',
    multipleReceiverTip: 'Multiple receivers detected, please keep only one',
    step1: {
      title: 'Step 1',
      content: 'Plug the receiver into the computer',
    },
    step2: {
      title: 'Step 2',
      content:
        'Toggle the power switch to OFF, disconnect the wired connection, then toggle it back to ON',
    },
    dialog: {
      instructionMouse: 'Press the left, middle, and right mouse buttons simultaneously',
      instructionAutoPairing:
        'Keep the mouse and receiver connected to the computer and wait for pairing to complete automatically',
      instructionKeyboard:
        'Make sure set to 2.4G mode\nPress and hold based on the model number "{combinedKeys}"',
      success: 'Pairing successful',
      fail: 'Pairing failed',
      cancel: 'Cancel',
      pairing: 'Pairing...',
      retry: 'Retry',
      confirm: 'Confirm',
    },
  },
}
